export default __webpack_public_path__ + "static/media/mdi_bag-checked.641131af.svg";